import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description InternetMarketer icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { InternetMarketer } from '@sravni/design-system-icons'
 *
 * <InternetMarketer />
 * ```
 */
var InternetMarketer = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "InternetMarketer", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.07 10.13V7.5h-2.63M16.57 5l.834-.833", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.736 4.167H4.903c-.92 0-1.667.745-1.667 1.666v10c0 .921.746 1.667 1.667 1.667h10.833c.921 0 1.667-.746 1.667-1.667v-4.166M17.402 7.5h1.175M14.07 4.167V2.992", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M3.236 11.35c6.667 1.498 9.792-2.808 9.792-2.808", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { InternetMarketer };
//# sourceMappingURL=InternetMarketer.js.map
